import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_67: FaireProductEntity = {
  token: "legacy_prod_abbott-67",
  type: "product",
  name: "Marine Kingdom Lined Notebook A5",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/9de9863df71ecfb4cb383e17ef33c72e4a34042a367785cb1e42f3856cf8c40e.jpeg",
  priceDollars: 10,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_stationery-writing"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
